import type { User } from "./types";

export async function confirmSignedInEmailIsVerified(
  isAuthenticated: boolean,
  refreshUser: () => Promise<User>,
): Promise<boolean> {
  if (!isAuthenticated) return false;

  try {
    const currentUser = await refreshUser();
    return currentUser.isEmailVerified === true;
  } catch {
    return false;
  }
}
